import { formatKeyMethodsByLine } from '@/infrastructure/format-data';
import { IProblemAccountDetail } from '@/presentation/pages/compliance/self-launch/detail/api';

// Service#OnBind Service#OnStart Receiver#OnReceive
export const isActionLaunch = (autoCallType?: string | null) => ['1', '2', '3'].includes(autoCallType || '');
// Provider#OnCreate Provider#Insert Provider#Delete Provider#Update Provider#Query
export const isProviderLaunch = (autoCallType?: string | null) => ['4', '5', '6', '7', '8', '9'].includes(autoCallType || '');
// Receiver#RelationBoot Service#RelationBoot Provider#RelationBoot
export const isRelationLaunch = (autoCallType?: string | null) => ['10', '11', '12'].includes(autoCallType || '');

export const getComponentInfo = (info?: IProblemAccountDetail) => {
  if (isRelationLaunch(info?.autoCallType)) {
    return { label: '关联启动行为', info: info?.componentInfo || '【空】' };
  }
  return { label: '启动组件名', info: info?.componentInfo || '【空】' };
};

export const getKeyInfo = (info?: IProblemAccountDetail) => {
  const keyInfo: { label: string; info: string }[] = [];

  if (isActionLaunch(info?.autoCallType)) {
    keyInfo.push(...[
      { label: 'ActionUrl信息', info: info?.keyAction || '【空】' },
      { label: 'Intent信息', info: info?.keyIntent || '【空】' },
    ]);
  }

  if (isProviderLaunch(info?.autoCallType)) {
    keyInfo.push({ label: 'ProviderUrl信息', info: info?.keyProviderUri || '【空】' });
  }

  if (isRelationLaunch(info?.autoCallType)) {
    keyInfo.push({ label: '触发信息', info: info?.keyIntent || '【空】' });
  }

  return keyInfo;
};

export const getSelfLaunchKeyMethods = (info?: IProblemAccountDetail) => {
  const keyMethods = [
    getComponentInfo(info),
    ...getKeyInfo(info),
  ].map(item => `${item.label}：${item.info}`);

  if (isRelationLaunch(info?.autoCallType)) {
    keyMethods.push(...formatKeyMethodsByLine(info?.keyTrace));
  }
  return keyMethods;
};
